import Http from "./http";

export const analyticsAPI = (data) => {
  return Http.post("analytics/getAnalytics",data);
};

export const getAnalyticsAPI = (data) => {
  return Http.post("analytics/appDownloads",data);
};